import {Temp} from "../utils/Temp.js";
import {SimpleEditor} from "../editors/SimpleEditor.js";
import {CategoriesPanel} from "./CategoriesPanel.js";

const DROP_H_MARGIN = 6;
const INDENT = 18;

/**
 * Options:
 * 		categories - definition of categories (see Java Categories class)
 * 		multi {boolean} - allows multiple items to be selected at once
 * 		placeholder {string|function} - string or function returning placeholder used for empty selection (defaults to "-")
 * 		readOnly {boolean} - editor is readonly
 */

export class CategoriesDirectEditor extends SimpleEditor {

	constructor(fieldPath, obj, member, options) {
		super(null, fieldPath, obj, member, options);
	}

	rebuild() {
		super.rebuild();
		this.widget = this.makePanel()
		if (this.readOnly) this.widget.addClass("readonly");
		else this.widget.attr("tabindex", this.options.tabindex ? this.options.tabindex : "10");	// elements with tabindex can receive focus events
		this.root.append(this.widget);
		this.root.addClass('cats-dropdown-direct');
		this.updateScreen(this.normalizedData());
	}


	selectedValues() {
		const allChecked = this.root.find("input[type=checkbox]:checked");
		return CategoriesPanel.extractDataFromCheckboxes(allChecked);
	}

	/**
	 * Checkbox in the drop down was (un)selected
	 */
	selectionChanged(id, checked) {
		this.data = this.selectedValues();
	}
	
	updateScreen(dataArray) {
		const all = this.root.find("input[type=checkbox]");
		CategoriesPanel.updateCheckboxesFromData(all, dataArray);
	}

	normalizedData() {
		let d = this.data;
		if (typeof d === "undefined") d = [];
		else if (typeof d === "string") d = [d];
		return d;
	}
	
	
	
	makePanel() {
		const panel = CategoriesPanel.generateChildrenPanel(this.options.categories.children);
		panel.on("selectionchange", function(e, id, checked) {
			this.selectionChanged(id, checked);
		}.bind(this));
		return panel;
	}
}